export default __webpack_public_path__ + "static/media/graph.205ae3dd.png";